interface ExperienceLike {
  id?: number;
  title?: string;
  workplaceName?: string;
  company?: string;
}

/**
 * "Title · Company" per experience id, so a reference card can say which job
 * it is about now that references are listed in one section instead of under
 * each experience. Works for both the recruiter CV shape and the own-resume one.
 */
export const experienceLabelsById = (experiences: ExperienceLike[] | undefined): Record<string, string> => {
  const labels: Record<string, string> = {};
  (experiences ?? []).forEach((experience) => {
    if (experience.id === undefined) {
      return;
    }
    const label = [experience.title, experience.workplaceName || experience.company]
      .filter(Boolean)
      .join(' · ');
    if (label) {
      labels[String(experience.id)] = label;
    }
  });
  return labels;
};
